import FUNDRAISER_ROUTES from './fundraiser'

const routeDashboard = '/dashboard'

export const ROUTES = {
  root: {
    key: 'root',
    title: 'صفحه اصلی | زیما',
    name: 'زیما',
    href: '/',
  },
  register: {
    key: 'register',
    title: 'ثبت نام زیما',
    name: 'ثبت نام زیما',
    href: '/register',
  },
  registerMobile: {
    key: 'register-user',
    title: 'ثبت نام زیما',
    name: 'ثبت نام زیما',
    href: '/register-user',
  },
  otpVerification: {
    key: 'otp-verification',
    title: 'تایید شماره موبایل زیما',
    name: 'تایید شماره موبایل زیما',
    href: '/otp-verification',
  },
  mobileOtpVerification: {
    key: 'mobile-otp-verification',
    title: 'تایید شماره موبایل زیما',
    name: 'تایید شماره موبایل زیما',
    href: '/mobile-otp-verification',
  },
  login: {
    key: 'login',
    title: 'ورود سایت زیما',
    name: 'ورود / ثبت‌نام',
    href: '/login',
  },
  crowdfundingPlan: {
    key: 'crowdfundingPlan',
    title: 'لیست طرح های کرادفاندینگ زیما',
    name: 'مشاهده طرح‌های سرمایه‌گذاری',
    href: '/crowdfunding-plan',
  },
  crowdfundingInvest: {
    key: 'crowdfundingInvest',
    title: 'سرمایه گذاری در طرح زیما',
    name: 'سرمایه گذاری در طرح زیما',
    href: '/crowdfunding/invest',
  },
  dashboard: {
    root: {
      key: 'dashboard',
      title: 'پروفایل من',
      name: 'پروفایل من',
      href: routeDashboard,
    },
    crowdfundingPlans: {
      key: 'crowdfundingPlans',
      title: 'طرح‌های سرمایه‌گذاری',
      name: 'طرح‌های سرمایه‌گذاری',
      href: `${routeDashboard}/crowdfunding-plans`,
    },
    userInformation: {
      key: 'userInformation',
      title: 'اطلاعات کاربری - پروفایل من',
      name: 'اطلاعات کاربری',
      href: `${routeDashboard}/user-information`,
    },
    userCrowdfundingPlan: {
      key: 'userCrowdfundingPlan',
      title: 'طرح های من',
      name: 'سرمایه‌گذاری‌های من',
      href: `${routeDashboard}/user-crowdfunding-plan`,
    },
  },
  rules: {
    key: 'rules',
    title: 'قوانین و مقررات زیما',
    name: 'قوانین و مقررات زیما',
    href: '/rules',
  },
  faq: {
    key: 'faq',
    title: 'سوالات متداول پلتفرم کرادفاندینگ زیما',
    name: 'پرسش‌های متداول',
    href: '/faq',
  },
  blog: {
    key: 'blog',
    title: 'بلاگ زیما',
    name: 'بلاگ',
    href: '/blog',
  },
  about: {
    key: 'about',
    title: 'درباره زیما پلتفرم تامین مالی جمعی',
    name: 'درباره زیما',
    href: '/about',
  },
  terms: {
    key: 'terms',
    title: 'موافقتنامه استفاده از خدمات (شرایط عمومی)',
    name: 'موافقتنامه استفاده از خدمات (شرایط عمومی)',
    href: '/rules',
  },
  ...FUNDRAISER_ROUTES,
}
